// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gyarados: PokeData = {
  "id": 130,
  "name": "gyarados",
  "height": 65,
  "weight": 2350,
  "base_experience": 189,
  "types": [
    PokeType.WATER,
    PokeType.FLYING
  ],
  "api_moves": [
    "bind",
    "tackle",
    "thrash",
    "leer",
    "bite",
    "hydro-pump",
    "hyper-beam",
    "dragon-rage",
    "rage",
    "focus-energy",
    "waterfall",
    "splash",
    "flail",
    "scary-face",
    "outrage",
    "twister",
    "rain-dance",
    "crunch",
    "whirlpool",
    "dragon-dance",
    "water-pulse",
    "brine",
    "aqua-tail",
    "ice-fang",
    "dragon-tail",
    "hurricane"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "hydro-pump",
    "splash",
    "scary-face",
    "outrage",
    "rain-dance",
    "crunch",
    "whirlpool",
    "dragon-dance",
    "brine",
    "aqua-tail"
  ],
  "evolution_chain": {
    "id": 64,
    "item": null,
    "species": [
      {
        "name": "magikarp",
        "order": 153,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "gyarados",
        "order": 154,
        "types": [
          PokeType.WATER,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 129,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 124,
    "speed": 109,
    "ability_power": 168
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
